import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/units')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/units/' + id , payload)       
    } else {
        return Api.post('api/units' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/units/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/units/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};